

import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal } from "../modal/modalSlice";

const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

const placeholderKayitItem = {

    companyId: JSON.parse(storage.getItem("companyId")),
    fromCityId: "",
    fromCity: "",
    fromTownId: "",
    fromTown: "",
    toCityId: "",
    toCity: "",
    toTownId: "",
    toTown: "",

    transportOffers:[
        {
            aracTuruId: 4,
            aracTuruName: "Tır",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        },
        {
            aracTuruId: 3,
            aracTuruName: "Kırkayak",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        },
        {
            aracTuruId: 5,
            aracTuruName: "10 Teker",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        },
        {
            aracTuruId: 6,
            aracTuruName: "6 Teker",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        },
        {
            aracTuruId: 7,
            aracTuruName: "Kamyon Römork",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        },
        {
            aracTuruId: 1,
            aracTuruName: "Kamyonet",
            lightWeightPrice: "",
            normalWeightPrice: "",
            heavyWeightPrice: ""
        }
    ]
}

const initialState = {

    isLoadingGetBolgedekiTeklifler: false,

    bolgedekiTeklifler: [],
    constantBolgedekiTeklifler: [],

    isLoadingAddOrUpdateBolgeTeklif: false,

    hiddenAracColumnList: [],

    bolgedekiTeklifItem: null,

    anyQuery: false
}



export const getBolgedekiTekliflerim = createAsyncThunk("bolgedekiTekliflerim/getBolgedekiTekliflerim", async({fromCityId="", fromTownId="", toCityId="", toTownId=""}, thunkApi)=> {

    try {
        const {data} = await axiosInstance.get(`/TransportOffer/GetAllCompanyTransportOffers?companyId=${JSON.parse(storage.getItem("companyId"))}&&fromCityId=${fromCityId}&&fromTownId=${fromTownId}&&toCityId=${toCityId}&&toTownId=${toTownId}`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const addOrUpdateBolgeTeklif = createAsyncThunk("bolgedekiTekliflerim/addOrUpdateBolgeTeklif", async(updatedList, thunkApi)=> {
    try {
        const formattedList = updatedList.map((item) => {
            return {
                ...item, 
                transportOffers: item.transportOffers.map(innerItem => {
                    return {
                        ...innerItem,
                        lightWeightPrice: innerItem.lightWeightPrice ? parseInt(innerItem.lightWeightPrice) : 0,
                        normalWeightPrice: innerItem.normalWeightPrice ? parseInt(innerItem.normalWeightPrice) : 0,
                        heavyWeightPrice: innerItem.heavyWeightPrice ? parseInt(innerItem.heavyWeightPrice) : 0,
                    }
                }) 
            }
        })
        const {data} = await axiosInstance.post(`/TransportOffer/CreateOrUpdateTransportOffer`, formattedList)
        if(data.$values.length > 0){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(setResultModalData({ msg: "Güncelleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
          }
        // const currentlist = thunkApi.getState().bolgedekiTeklifler.bolgedekiTeklifler.slice(0, -1);
        // const placeholderItem = thunkApi.getState().bolgedekiTeklifler.bolgedekiTeklifler[thunkApi.getState().bolgedekiTeklifler.bolgedekiTeklifler.length-1]
        
        // return {currentlist, placeholderItem, newList: data.$values.map((item) => {
        //     return {...item, transportOffers: item.transportOffers.$values}
        // })
    // }
    thunkApi.dispatch(getBolgedekiTekliflerim())

    } catch (error) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteBolgeTeklifItem = createAsyncThunk("bolgedekiTekliflerim/deleteBolgeTeklifItem", async(id, thunkApi)=> {
    try {
        const {data} = await axiosInstance.delete(`/TransportOffer/DeleteCompanyTransportOffer?id=${id}`)
        if(data.id){
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(setResultModalData({ msg: "Silme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
          }
        return data
    } catch (error) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(setResultModalData({ msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
        return thunkApi.rejectWithValue(error)
    }
})





const bolgedekiTekliflerimSlice = createSlice({
    name: "bolgedekiTekliflerim",
    initialState,
    reducers: {

        addNewBolgeTeklifRow: (state) => {
            state.bolgedekiTeklifler = [...state.bolgedekiTeklifler, {...placeholderKayitItem, id: nanoid()}]
        },

        updateBolgedekiTekliflerItemPrice: (state, action) => {
            const {key, value, itemId, aracTuruId} = action.payload
            
            
            state.bolgedekiTeklifler = state.bolgedekiTeklifler.map((item) => {
                if(itemId === item.id){
                    return {
                        ...item, transportOffers: item.transportOffers.map((innerItem) => {
                            if(innerItem.aracTuruId === aracTuruId){
                                return {
                                    ...innerItem,
                                    [key]: value
                                }
                            }
                            else{
                                return innerItem
                            }
                        }) 
                    }
                }
                else{
                    return item
                }
            })
        },

        updateBolgedekiTekliflerItemLocation: (state, action) => {
            const {locationData, id, keyData} = action.payload

            state.bolgedekiTeklifler = state.bolgedekiTeklifler.map((item) => {
                if(item.id === id){
                    const updatedData = keyData === "from" ? {
                        fromCityId: parseInt(locationData.cityId),
                        fromCity: locationData.city,
                        fromTownId: parseInt(locationData.townId),
                        fromTown: locationData.town
                    }: {
                        toCityId: parseInt(locationData.cityId),
                        toCity: locationData.city,
                        toTownId: parseInt(locationData.townId),
                        toTown: locationData.town,
                    }
                    return {
                        ...item, ...updatedData
                    }
                }
                return item
            })
        },

        setHiddenAracColumnList: (state, action) => {
            if(state.hiddenAracColumnList.includes(action.payload)){
                state.hiddenAracColumnList = state.hiddenAracColumnList.filter(item => {
                    return item !== action.payload
                })
            }
            else{
                state.hiddenAracColumnList = state.hiddenAracColumnList.length < 5 ? [...state.hiddenAracColumnList, action.payload] : state.hiddenAracColumnList 
            }
        },

        setBolgedekiTeklifItem: (state, action) => {
            state.bolgedekiTeklifItem = action.payload
        },

        setAnyQuery: (state,action) => {
            state.anyQuery = action.payload
        }
    },


    extraReducers:(builder)=> {
        builder

        //! getBolgedekiTekliflerim
        .addCase(getBolgedekiTekliflerim.pending, (state)=> {
            state.isLoadingGetBolgedekiTeklifler = true
        })

        .addCase(getBolgedekiTekliflerim.fulfilled, (state, action)=> {
            state.isLoadingGetBolgedekiTeklifler = false
            state.constantBolgedekiTeklifler = action.payload.$values.length > 0 ? action.payload.$values.map((item) => {
                return {...item, transportOffers: item.transportOffers.$values}
            }) : [placeholderKayitItem, placeholderKayitItem, placeholderKayitItem, placeholderKayitItem, placeholderKayitItem] 
            state.bolgedekiTeklifler = action.payload.$values.length > 0 ? action.payload.$values.map((item) => {
                return {...item, transportOffers: item.transportOffers.$values}
            }) : !state.anyQuery ? [placeholderKayitItem, placeholderKayitItem, placeholderKayitItem, placeholderKayitItem, placeholderKayitItem] : [] 
            
        })

        .addCase(getBolgedekiTekliflerim.rejected, (state, action)=> {
            state.isLoadingGetBolgedekiTeklifler = false
            state.isErrorFeedback = true
        })


        //! addOrUpdateBolgeTeklif
        .addCase(addOrUpdateBolgeTeklif.pending, (state)=> {
            state.isLoadingAddOrUpdateBolgeTeklif = true
        })

        .addCase(addOrUpdateBolgeTeklif.fulfilled, (state, action)=> {
            state.isLoadingAddOrUpdateBolgeTeklif = false
            // const {currentlist, newList, placeholderItem} = action.payload
            // console.log(currentlist, newList, placeholderItem);
            // const currentIdList = currentlist.map(item => item.id)
            // const newItemList = newList.filter(item => {
            //     return !currentIdList.includes(item.id)
            // }) 
            // const updatedItemList = newList.filter(item => {
            //     return currentIdList.includes(item.id)
            // }) 

            // const updatedList = [...currentlist.map((item) => {
            //     const isUpdatedItem = updatedItemList.find(innerItem => innerItem.id === item.id) 
            //   if(isUpdatedItem){
            //     return isUpdatedItem
            //   }  
            //   else{
            //     return item
            //   }
            // }), ...newItemList, placeholderItem]

            // state.bolgedekiTeklifler = updatedList

            // console.log(newItemList);
            // console.log(updatedItemList);

        })

        .addCase(addOrUpdateBolgeTeklif.rejected, (state, action)=> {
            state.isLoadingAddOrUpdateBolgeTeklif = false
        })



        
        //! deleteBolgeTeklifItem
        .addCase(deleteBolgeTeklifItem.pending, (state)=> {
            state.isLoadingGetBolgedekiTeklifler = true
        })

        .addCase(deleteBolgeTeklifItem.fulfilled, (state, action)=> {
            state.isLoadingGetBolgedekiTeklifler = false
            state.bolgedekiTeklifler = state.bolgedekiTeklifler.filter(item => {
                return item.id !== action.payload.id
            })
        })

        .addCase(deleteBolgeTeklifItem.rejected, (state, action)=> {
            state.isLoadingGetBolgedekiTeklifler = false
        })


    }
})


export const { addNewBolgeTeklifRow, updateBolgedekiTekliflerItemPrice, updateBolgedekiTekliflerItemLocation, setHiddenAracColumnList, setBolgedekiTeklifItem, setAnyQuery} = bolgedekiTekliflerimSlice.actions
export default bolgedekiTekliflerimSlice.reducer